/**
 * Before creating a regexp from a string we should escape the string for regexp-control chars
 *
 * https://sentry.io/organizations/bravado-network/issues/3764681538/?project=5952605&query=is%3Aunresolved&referrer=issue-stream&statsPeriod=14d
 */
export const escapeRegExp = (val: string): string => {
  return val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
